import { Identified } from './Identified';

export interface UnitCategory extends Identified {
  readonly code: string;
  readonly description: string;
  readonly filterLabel: string;
}

export interface FlamingoUnitCategory extends Identified {
  readonly code: UnitCategoryCode;
  readonly description: string;
  readonly filterLabel: string;
}

export enum UnitCategoryCode {
  A = 'A',
  K = 'K',
  E = 'E',
  F = 'F',
  S = 'S',
  T = 'T',
  W = 'W',
}
